module.exports = __webpack_public_path__ + "img/verne.65675886.jpg";